import { useEffect, useState, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  getDocs,
} from "firebase/firestore";
import HomePage from "../../pages/home/HomePage";
import { db } from "../../matabase";

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [err, setErr] = useState(null);
  const [load, setLoad] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [lastDoc, setLastDoc] = useState(null); // 👈 Track last doc for pagination
  const limitNum = 4;

  const cat = useLocation().search.split("=")[1];

  const observer = useRef();
  const lastPostRef = useCallback(
    (node) => {
      if (load) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchData(); // load more when last post visible
        }
      });
      if (node) observer.current.observe(node);
    },
    [load, hasMore]
  );

  // Reset when category changes
  useEffect(() => {
    setPosts([]);
    setLastDoc(null);
    setHasMore(true);
    fetchData(true);
  }, [cat]);

  const fetchData = async (reset = false) => {
    try {
      setLoad(true);

      let q = query(collection(db, "posts"), orderBy("date"), limit(limitNum));

      if (cat) {
        q = query(
          collection(db, "posts"),
          orderBy("date", "desc"),
          where("cat", "==", cat),
          limit(limitNum)
        );
      } else {
        q = query(
          collection(db, "posts"),
          orderBy("date", "desc"),
          limit(limitNum)
        );
      }

      if (lastDoc && !reset) {
        q = query(q, startAfter(lastDoc));
      }

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const newPosts = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPosts((prev) => {
          const ids = new Set(prev.map((p) => p.id));
          const filtered = newPosts.filter((p) => !ids.has(p.id));
          return [...prev, ...filtered];
        });

        setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
        setHasMore(snapshot.docs.length === limitNum);
      } else {
        setHasMore(false);
      }

      setLoad(false);
    } catch (error) {
      console.log(error.message);
      setErr("Something went wrong fetching posts");
      setLoad(false);
    }
  };

  return (
    <div>
      {err ? (
        <p className="load-err">{err}</p>
      ) : (
        <HomePage posts={posts} lastPostRef={lastPostRef} />
      )}
      {load && (
        <p className={posts.length === 0 ? "load-err" : ""}>Loading...</p>
      )}
      {!err && !load && posts.length === 0 && (
        <p className="load-err">No blogs found</p>
      )}
    </div>
  );
};

export default Home;
